var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49994 7.17614C8.08057 7.17614 8.55127 6.48728 8.55127 5.90114C8.55127 5.315 8.08057 4.83984 7.49994 4.83984C6.9193 4.83984 6.4486 5.315 6.4486 5.90114C6.4486 6.48728 6.9193 7.17614 7.49994 7.17614Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34595 10.3814C4.74212 9.06969 6.00424 8.11068 7.49995 8.11068C8.99567 8.11068 10.2578 9.06969 10.654 10.3814C8.02693 11.3464 5.35402 10.7835 4.34595 10.3814Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8C14.25 11.7279 11.2279 14.75 7.5 14.75C3.77208 14.75 0.75 11.7279 0.75 8C0.75 4.27208 3.77208 1.25 7.5 1.25C11.2279 1.25 14.25 4.27208 14.25 8Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.082936b7cfb953eef86d7e1854f51b66.svg";
export { ForwardRef as ReactComponent };